import React from "react";
import styled from "@emotion/styled";
import PropsVisuallyHidden from "../../types/PropsVisuallyHidden";

const StyledNoSpace = styled("span")`
  &:not(:focus):not(:focus-within):not(:active) {
    position: absolute;
    height: 1px;
    width: 1px;
    border: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap;
  }
`;

const StyledReserveSpace = styled("span")`
  &:not(:focus):not(:focus-within):not(:active) {
    color: transparent;
    background: transparent;
    background-color: transparent;
    border: transparent;
    border-color: transparent;
    text-decoration-color: transparent;
    box-shadow: none;
  }
`;

const StyledWrapper = styled("div")`
  position: relative;
  z-index: 100000;
`;

const StyledOverlaySpace = styled("span")`
  position: absolute;
  top: 0;
  left: 0;
  &:not(:focus):not(:focus-within):not(:active) {
    position: absolute;
    height: 1px;
    width: 1px;
    border: 0;
    padding: 0;
    margin: 0;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
    white-space: nowrap;
  }
`;

const VisuallyHidden = (props: PropsVisuallyHidden) => {
  const { space } = props;
  if (space === "reserve") {
    return <StyledReserveSpace {...props} />;
  }
  if (space === "overlay") {
    return (
      <StyledWrapper>
        <StyledOverlaySpace {...props} />
      </StyledWrapper>
    );
  }
  return <StyledNoSpace {...props} />;
};

export default VisuallyHidden;
